import { useQuery } from '@tanstack/react-query'
import { sellerService } from '../services/sellersService'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect } from 'react'

export const useSellerInfo = (id: string) => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['sellerInfo', id],
    queryFn: async () => sellerService.sellerInfo(id),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
